import dayjs from "dayjs";
import { DAYJS_MANTINE_DATEFORMAT } from "./dates/dates.constants";

/** Parses a given string to a Date-String supported by mantine, using dayjs
since Mantine 8 it uses dateformat: 1988-12-19
dayjs-format: YYYY-MM-DD
luxon-format: yyyy-MM-dd
*/
export function parseManualDateInput(input: string) {
  return dayjs(input, [
    "D.M.YYYY",
    "D.MM.YYYY",
    "DD.M.YYYY",
    "DD.MM.YYYY"
  ]).format(DAYJS_MANTINE_DATEFORMAT);
}
